"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthSelector = void 0;
const react_1 = __importDefault(require("react"));
const AuthSelector = ({ configs, }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null, configs.map((config) => {
        return (react_1.default.createElement("li", { className: "firebaseui-list-item", key: config.providerId },
            react_1.default.createElement("button", { className: "firebaseui-idp-button mdl-button mdl-js-button mdl-button--raised firebaseui-idp-password firebaseui-id-idp-button", 
                // data-provider-id={config.providerId}
                style: {
                    backgroundColor: config.backgroundColor,
                }, onClick: config.handler },
                react_1.default.createElement("span", { className: "firebaseui-idp-icon-wrapper" },
                    react_1.default.createElement("img", { style: config.imageStyle, className: "firebaseui-idp-icon", alt: "", src: config.iconUrl })),
                react_1.default.createElement("span", { className: "firebaseui-idp-text firebaseui-idp-text-long", style: {
                        color: config.color,
                    } }, config.fullLabel),
                react_1.default.createElement("span", { className: "firebaseui-idp-text firebaseui-idp-text-short", style: {
                        color: config.color,
                    } }, config.shortLabel))));
    })));
};
exports.AuthSelector = AuthSelector;
